import React, { useRef, useState } from 'react';
import { toast } from 'sonner';
import { UploadCloud } from 'lucide-react';

// Drag-and-drop (or click) bulk SVG upload; each file becomes a faceplate template named after the file.
export const FaceplateDropZone = ({ api, onUploaded }) => {
  const [over, setOver] = useState(false);
  const [busy, setBusy] = useState('');
  const ref = useRef(null);
  const upload = async (files) => {
    const svgs = [...files].filter(f => /\.svg$/i.test(f.name) || f.type === 'image/svg+xml');
    if (!svgs.length) { toast.error('Only .svg files can be uploaded'); return; }
    const made = [];
    for (const [i, f] of svgs.entries()) {
      setBusy(`Uploading ${i + 1} of ${svgs.length}: ${f.name}`);
      const fd = new FormData();
      fd.append('name', f.name.replace(/\.svg$/i, '')); fd.append('product_keys', ''); fd.append('file', f);
      try { made.push((await api().post('/faceplates', fd)).data); } catch (e) { toast.error(`${f.name}: ${e.response?.data?.detail || 'upload failed'}`); }
    }
    setBusy('');
    if (made.length) { toast.success(`Uploaded ${made.length} faceplate${made.length > 1 ? 's' : ''}. Link products and fields next.`); onUploaded(made); }
  };
  return (
    <div onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)}
      onDrop={(e) => { e.preventDefault(); setOver(false); upload(e.dataTransfer.files); }} onClick={() => ref.current?.click()}
      className={`cursor-pointer border-2 border-dashed rounded-sm p-6 text-center transition-colors ${over ? 'border-blue-500 bg-blue-50' : 'border-slate-300 hover:border-slate-500 bg-slate-50/50'}`} data-testid="fp-dropzone">
      <UploadCloud className="w-8 h-8 mx-auto text-slate-400" />
      <p className="text-sm font-semibold mt-2">{busy || 'Drop your SVG faceplate files here, or click to choose'}</p>
      <p className="text-xs text-slate-500 mt-1">You can upload several at once. Keep the variable text (serial, date, etc.) as live text, not outlines, so it can be filled in.</p>
      <input ref={ref} type="file" multiple accept=".svg,image/svg+xml" className="hidden" onChange={(e) => { upload(e.target.files); e.target.value = ''; }} data-testid="fp-dropzone-input" />
    </div>
  );
};

export default FaceplateDropZone;
